module.exports = __webpack_public_path__ + "img/pdf-file (SVG).d66577fa.svg";